export enum UserRole {
    STUDENT = 'student',
}